export default { 
    minVersion: 100,
}